import { __ } from "src/libs/utilities"
import { components } from "src/modules/pe-landing-module/data/utils/components"

const getNewMeatTitle = (name: string, i: number): string[ ] => {
    const item = components()[ name ]?.default ? components()[ name ]?.default[ i ] : {}
    return !!item?.defaultTitle 
        ? 
        [
            __( item.defaultTitle ),
            __( item.defaultDescription || "")
        ]    
        :  
        [ 
            __( components()[ name ]?.title || name ) + " " + i 
        ]
}
export default getNewMeatTitle